import CommonRoutes from "./Routes/CommonRoutes";
import { ToastContainer, toast, Zoom } from "react-toastify";
import { messaging } from "./utility/Firebase/Firebase";
import { onMessage } from "firebase/messaging";
import { useEffect, useState } from "react";
import { apiUrl } from "./ApiHelper/ApiUrl";
import { callApi } from "./ApiHelper/ApiHelper";
import { useDispatch } from "react-redux";
import { saveNotificationsCount } from "./store/actions/UserActions";
import NoInternet from "./Pages/CommonPages/NoInternet";
import useResetOnReload from "./hook/useResetOnReload";
import { v4 as uuidv4 } from "uuid";

// Assign a unique ID to the current tab session
window.__TAB_ID = uuidv4();

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const dispatch = useDispatch();

  useResetOnReload();

  // Register Service Worker
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .catch((error) => {
          console.error("Service Worker registration failed:", error);
        });
    });
  }

  useEffect(() => {
    // Firebase notification listener
    onMessage(messaging, (payload) => {
      getNotificationCount();
      toast.info(`${payload?.notification?.title}`, {
        position: "bottom-right",
        autoClose: 5000,
      });
    });

    // Internet detection
    const handleOffline = () => setIsOnline(false);
    const handleOnline = () => setIsOnline(true);

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    // Listen for token change in other tabs (localStorage method)
    const handleStorageChange = (event) => {
      if (event.key === "token" && event.oldValue !== event.newValue) {
        window.location.reload();
      }
    };
    window.addEventListener("storage", handleStorageChange);

    // Fallback: BroadcastChannel (works even if storage doesn't)
    const channel = new BroadcastChannel("auth");
    channel.onmessage = (event) => {
      // Ignore messages sent from the current tab
      if (
        event.data?.sourceTabId &&
        event.data?.sourceTabId === window.__TAB_ID
      ) {
        return;
      }

      const messageType =
        typeof event.data === "string" ? event.data : event.data?.type;

      if (messageType === "logout" || messageType === "login") {
        window.location.reload();
      }
    };

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("storage", handleStorageChange);
      channel.close();
    };
  }, []);

  if (isOnline === false) {
    return <NoInternet />;
  }

  const getNotificationCount = () => {
    const apiURL = apiUrl?.get_notification_count;
    callApi(apiURL, { method: "GET" }).then((response) => {
      if (response?.status === true) {
        dispatch(saveNotificationsCount(response?.data));
      }
    });
  };

  return (
    <>
      <CommonRoutes />
      <ToastContainer
        autoClose={2000}
        hideProgressBar
        closeOnClick
        transition={Zoom}
        theme="light"
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
        position="top-center"
      />
    </>
  );
}

export default App;
